import {useState} from 'react';
import dynamic from 'next/dynamic';
import {useFormContext} from 'react-hook-form';
import {Grid, Typography} from '@mui/material';
import {CommonFields} from '../CommonFields';
const FileUploader = dynamic(
  () =>
    import('@/shared/components/forms/theme-elements/form/fileUploader').then(
      (mod) => mod.FileUploader
    ),
  {ssr: false}
);

export const RoutePlan = () => {
  const [fileLoading, setFileLoading] = useState(false);

  const {watch, setValue} = useFormContext();

  const values = watch('menus.navigations.routePlan') || {};

  return (
    <Grid container>
      <CommonFields name={'menus.navigations.routePlan'} />

      <Grid item md={6} mt={2}>
        <Typography variant='h6' mb={2}>
          Image
        </Typography>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 530, height: 430}}}
          label={'Image'}
          name={'menus.navigations.routePlan.image'}
          setFileUrl={(links) =>
            setValue(`menus.navigations.routePlan.image`, links[0])
          }
          destination={'landing-pages'}
          values={values?.image}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>
    </Grid>
  );
};
